import { SidebarHeader as SidebarHeaderUI } from "@/_old/components/ui/sidebar";
import LogoHorizontal from "@/_old/assets/icons/logo-horizontal.svg?react";
import { useSidebar } from "@/_old/components/ui/sidebar";

export function SidebarHeader() {
  const { state } = useSidebar();

  const hideText = state === "collapsed";

  return (
    <>
      {!hideText && (
        <SidebarHeaderUI className="px-4 py-0 border-t-8 border-primary-500 bg-white/50">
          <div className="flex items-center justify-between">
            <LogoHorizontal />
          </div>
        </SidebarHeaderUI>
      )}
    </>
  );
}
